import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';

class ProfileImageViewer extends React.Component {
    render() {
        const { imageUrl, close, zIndex } = this.props;

        return (
            <Lightbox
                reactModalStyle={{
                    overlay: {
                        /*
                         * Above whatever opened it. The drawer this is now also
                         * called from sits at 60001, so a fixed 60000 put the
                         * enlarged photo behind the panel you clicked it in.
                         */
                        zIndex: zIndex || 60000,
                    },
                }}
                mainSrc={imageUrl}
                onCloseRequest={close}
                enableZoom={true}
            />
        );
    }
}

ProfileImageViewer.propTypes = {
    imageUrl: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
    zIndex: PropTypes.number,
};

export default ProfileImageViewer;



// WEBPACK FOOTER //
// ./src/components/ProfileImageViewer.jsx